<template>
<div
	class="flex items-center justify-center p-2 font-semibold text-white rounded-full avatar bg-accent"
	:class="[`avatar--${size}`]"
	:style="style"
	data-component="Avatar.vue"
>
	<BaseIcon v-if="!image && !initials" name="avatar" :size="4"/>
	<template v-else-if="!image">
		{{ Format.AvatarLetters(initials) }}
	</template>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlanie awatara użytkownika.
// @group Base Components
export default {
	name: 'BaseAvatar',
	props: {
		user: { type: Object, required: true },
		size: { type: String, default: 'lg' },
		hideImage: { type: Boolean, default: false },
	},
	computed: {
		image() {
			if (this.hideImage) { return ''; }
			return this.user?.Avatar || this.user?.path || '';
		},
		initials() {
			return this.user.FirstName
				? `${this.user.FirstName || ''} ${this.user.LastName || ''}`
				: '';
		},
		style() {
			return this.image
				? { 'background-image': `url(${this.image})` }
				: {
					'background-color': this.initials
						? this.Format.AvatarColor(this.initials)
						: '#eeeeee',
				};
		},
	},
};
</script>

<style lang="scss" scoped>
.avatar {
	background-size: cover;
	background-position: center;
	text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);

	&--sm {
		box-shadow: 0 0 1px black;
		width: 36px;
		height: 36px;
	}

	&--md {
		width: 60px;
		height: 60px;
		font-size: 24px;
    font-weight: 700;
	}

	&--lg {
		width: 100px;
		height: 100px;
		border: 8px solid #fff;
		font-size: 36px;
    font-weight: 800;
	}

	&--xl {
		width: 160px;
		height: 160px;
		font-size: 60px;
		border: 8px solid #fff;
    font-weight: 800;
	}
}
</style>
